import { BadgeStatuses } from "../../../../../../common/enums";
import { MUIDataTableCheckboxProps } from 'mui-datatables';
import { StatusTableRow } from "../tableRow/StatusTableRow";
import { Box, Checkbox } from "@mui/material";

type Props = {
  status?: BadgeStatuses;
  props: MUIDataTableCheckboxProps
}

export const StatusCheckboxTable = ({ props, status }: Props) => {
  return (
    <Box sx={{ width: "100%" }}>
      <StatusTableRow status={status}>
        <Checkbox {...props} />
      </StatusTableRow>
    </Box>
  );
}
